/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SwitchField,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Response } from "../models";
import { fetchByPath, validateField } from "./utils";
import { DataStore } from "aws-amplify";
export default function ResponseUpdateForm(props) {
  const {
    id: idProp,
    response: responseModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    sequence: "",
    text: "",
    questionText: "",
    userInitiated: false,
  };
  const [sequence, setSequence] = React.useState(initialValues.sequence);
  const [text, setText] = React.useState(initialValues.text);
  const [questionText, setQuestionText] = React.useState(
    initialValues.questionText
  );
  const [userInitiated, setUserInitiated] = React.useState(
    initialValues.userInitiated
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = responseRecord
      ? { ...initialValues, ...responseRecord }
      : initialValues;
    setSequence(cleanValues.sequence);
    setText(cleanValues.text);
    setQuestionText(cleanValues.questionText);
    setUserInitiated(cleanValues.userInitiated);
    setErrors({});
  };
  const [responseRecord, setResponseRecord] = React.useState(responseModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(Response, idProp)
        : responseModelProp;
      setResponseRecord(record);
    };
    queryData();
  }, [idProp, responseModelProp]);
  React.useEffect(resetStateValues, [responseRecord]);
  const validations = {
    sequence: [],
    text: [],
    questionText: [],
    userInitiated: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          sequence,
          text,
          questionText,
          userInitiated,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value.trim() === "") {
              modelFields[key] = undefined;
            }
          });
          await DataStore.save(
            Response.copyOf(responseRecord, (updated) => {
              Object.assign(updated, modelFields);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "ResponseUpdateForm")}
      {...rest}
    >
      <TextField
        label="Sequence"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={sequence}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              sequence: value,
              text,
              questionText,
              userInitiated,
            };
            const result = onChange(modelFields);
            value = result?.sequence ?? value;
          }
          if (errors.sequence?.hasError) {
            runValidationTasks("sequence", value);
          }
          setSequence(value);
        }}
        onBlur={() => runValidationTasks("sequence", sequence)}
        errorMessage={errors.sequence?.errorMessage}
        hasError={errors.sequence?.hasError}
        {...getOverrideProps(overrides, "sequence")}
      ></TextField>
      <TextAreaField
        label="User"
        isRequired={false}
        isReadOnly={false}
        value={text}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              sequence,
              text: value,
              questionText,
              userInitiated,
            };
            const result = onChange(modelFields);
            value = result?.text ?? value;
          }
          if (errors.text?.hasError) {
            runValidationTasks("text", value);
          }
          setText(value);
        }}
        onBlur={() => runValidationTasks("text", text)}
        errorMessage={errors.text?.errorMessage}
        hasError={errors.text?.hasError}
        {...getOverrideProps(overrides, "text")}
      ></TextAreaField>
      <TextAreaField
        label="Assistant"
        isRequired={false}
        isReadOnly={false}
        value={questionText}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              sequence,
              text,
              questionText: value,
              userInitiated,
            };
            const result = onChange(modelFields);
            value = result?.questionText ?? value;
          }
          if (errors.questionText?.hasError) {
            runValidationTasks("questionText", value);
          }
          setQuestionText(value);
        }}
        onBlur={() => runValidationTasks("questionText", questionText)}
        errorMessage={errors.questionText?.errorMessage}
        hasError={errors.questionText?.hasError}
        {...getOverrideProps(overrides, "questionText")}
      ></TextAreaField>
      <SwitchField
        label="User initiated"
        defaultChecked={false}
        isDisabled={false}
        isChecked={userInitiated}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              sequence,
              text,
              questionText,
              userInitiated: value,
            };
            const result = onChange(modelFields);
            value = result?.userInitiated ?? value;
          }
          if (errors.userInitiated?.hasError) {
            runValidationTasks("userInitiated", value);
          }
          setUserInitiated(value);
        }}
        onBlur={() => runValidationTasks("userInitiated", userInitiated)}
        errorMessage={errors.userInitiated?.errorMessage}
        hasError={errors.userInitiated?.hasError}
        {...getOverrideProps(overrides, "userInitiated")}
      ></SwitchField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || responseModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || responseModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
